import { Link } from 'react-router-dom'
import { Typography, Grid2, Button, styled } from '@mui/material'

interface GenericErrorProps {
  error: {
    message: string
    code: string
  }
}

const Container = styled(Grid2)({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  height: '100vh',
  width: "100vw"
})

export const GenericError = ({ error }: GenericErrorProps) => {
  const { message, code } = error
  return (
    <Container container rowSpacing={7}>
      <Grid2>
        <Typography variant="h1" component="h1" fontWeight="bolder">
          {code}
        </Typography>
      </Grid2>
      <Grid2>
        <Typography variant="h3" fontWeight="bolder">
          {message}
        </Typography>
      </Grid2>
      <Grid2>
        <Button
          variant="contained"
          component={Link}
          to={'http://yas.ymph.net/yas/home.php'}
        >
          <Typography>Go to Home Page</Typography>
        </Button>
      </Grid2>
    </Container>
  )
}
